import { action, observable } from 'mobx'

class MaterialStore {
    @observable
    materialStatus: boolean = false

    @observable
    keyWord: string = ''

    @action
    setKeyWord(w: string) {
        this.keyWord = w
    }

    @action
    setMaterialStatus() {
        this.materialStatus = !this.materialStatus
    }
}

export const materialStore = new MaterialStore()
